var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "b-card",
        [
          _c("div", { staticClass: "row mt-3" }, [
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "mr-2",
                    attrs: { variant: "primary", size: "sm" },
                    on: { click: _vm.voltar }
                  },
                  [
                    _c("i", { staticClass: "fas fa-arrow-left" }),
                    _vm._v("\n                    Voltar\n                ")
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-3", attrs: { "align-v": "end" } },
            [
              _c(
                "b-col",
                { attrs: { cols: "2" } },
                [
                  _c("label", [_vm._v("Produto")]),
                  _vm._v(" "),
                  _c("b-form-input", {
                    attrs: { placeholder: "Código ou Descrição", size: "sm" },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.getProdutos()
                      }
                    },
                    model: {
                      value: _vm.codigo,
                      callback: function($$v) {
                        _vm.codigo = $$v
                      },
                      expression: "codigo"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "2" } },
                [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Tipo de Produto")
                  ]),
                  _vm._v(" "),
                  _c("b-form-select", {
                    attrs: { options: ["VA", "AV", "TODOS"], size: "sm" },
                    model: {
                      value: _vm.tipo,
                      callback: function($$v) {
                        _vm.tipo = $$v
                      },
                      expression: "tipo"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Mostrar Indisponíveis")
                  ]),
                  _vm._v(" "),
                  _c("b-form-checkbox", {
                    model: {
                      value: _vm.indisponiveis,
                      callback: function($$v) {
                        _vm.indisponiveis = $$v
                      },
                      expression: "indisponiveis"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "text-left" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", size: "sm" },
                      on: {
                        click: function($event) {
                          return _vm.getProdutos()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fas fa-search" }),
                      _vm._v(" Buscar\n                ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "success", size: "sm" },
                      on: {
                        click: function($event) {
                          return _vm.exportar()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fas fa-file-excel" }),
                      _vm._v(" Exportar\n                ")
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-3", attrs: { "align-v": "end" } },
            [
              _c(
                "b-col",
                { attrs: { cols: "8" } },
                [
                  _c("b-pagination", {
                    staticClass: "my-0",
                    attrs: {
                      "total-rows": _vm.showProdutos.length,
                      "per-page": _vm.perPage,
                      align: "fill",
                      size: "sm"
                    },
                    model: {
                      value: _vm.currentPage,
                      callback: function($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { staticClass: "text-center" }, [
                _vm._v(
                  "\n                Total: " +
                    _vm._s(_vm.showProdutos.length) +
                    "\n            "
                )
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                [
                  _c("b-form-select", {
                    attrs: {
                      id: "per-page-select",
                      options: _vm.pageOptions,
                      size: "sm",
                      title: "Por Página"
                    },
                    model: {
                      value: _vm.perPage,
                      callback: function($$v) {
                        _vm.perPage = $$v
                      },
                      expression: "perPage"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row mt-3" },
            [
              _c("b-table", {
                attrs: {
                  hover: "",
                  striped: "",
                  "current-page": _vm.currentPage,
                  "per-page": _vm.perPage,
                  items: _vm.showProdutos,
                  busy: _vm.isLoading,
                  fields: _vm.header,
                  "sort-by": _vm.sortBy,
                  "sort-desc": _vm.sortDesc,
                  "sort-direction": _vm.sortDirection,
                  stacked: "md",
                  "show-empty": "",
                  small: ""
                },
                on: {
                  "update:sortBy": function($event) {
                    _vm.sortBy = $event
                  },
                  "update:sort-by": function($event) {
                    _vm.sortBy = $event
                  },
                  "update:sortDesc": function($event) {
                    _vm.sortDesc = $event
                  },
                  "update:sort-desc": function($event) {
                    _vm.sortDesc = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "table-busy",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          { staticClass: "text-center text-danger my-2" },
                          [
                            _c("b-spinner", { staticClass: "align-middle" }),
                            _vm._v(" "),
                            _c("strong", [_vm._v("Carregando ...")])
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "cell(id)",
                    fn: function(data) {
                      return [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              title: "Detalhar",
                              size: "sm",
                              variant: "primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.editar(data.item)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fas fa-eye" })]
                        )
                      ]
                    }
                  },
                  {
                    key: "cell(disponivel)",
                    fn: function(data) {
                      return [
                        data.item.disponivel
                          ? _c("b-badge", { attrs: { variant: "success" } }, [
                              _vm._v("Disponível")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !data.item.disponivel
                          ? _c("b-badge", { attrs: { variant: "danger" } }, [
                              _vm._v("Bloqueado")
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { size: "xl", title: _vm.produto.descricao },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function(ref) {
                var ok = ref.ok
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "danger" },
                      on: {
                        click: function($event) {
                          return ok()
                        }
                      }
                    },
                    [_vm._v("\n                Fechar\n            ")]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.modalProduto,
            callback: function($$v) {
              _vm.modalProduto = $$v
            },
            expression: "modalProduto"
          }
        },
        [
          _c(
            "b-overlay",
            { attrs: { show: _vm.loadingModal, rounded: "sm" } },
            [
              _c(
                "div",
                { staticClass: "card p-3" },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("label", [_vm._v("Código do Produto")]),
                        _vm._v(" "),
                        _c("b-form-input", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "XXXXXX",
                              expression: "'XXXXXX'"
                            }
                          ],
                          attrs: {
                            type: "text",
                            placeholder: "Código do produto",
                            disabled: ""
                          },
                          model: {
                            value: _vm.produto.codigo,
                            callback: function($$v) {
                              _vm.$set(_vm.produto, "codigo", $$v)
                            },
                            expression: "produto.codigo"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("label", [_vm._v("Descrição")]),
                        _vm._v(" "),
                        _c("b-form-input", {
                          attrs: { disabled: "" },
                          model: {
                            value: _vm.produto.descricao,
                            callback: function($$v) {
                              _vm.$set(_vm.produto, "descricao", $$v)
                            },
                            expression: "produto.descricao"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mt-3" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("label", [_vm._v("Marca")]),
                        _vm._v(" "),
                        _c("b-form-input", {
                          attrs: { disabled: "" },
                          model: {
                            value: _vm.produto.marca,
                            callback: function($$v) {
                              _vm.$set(_vm.produto, "marca", $$v)
                            },
                            expression: "produto.marca"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("label", [_vm._v("Qtd. Caixa")]),
                        _vm._v(" "),
                        _c("b-form-input", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "XX",
                              expression: "'XX'"
                            }
                          ],
                          attrs: {
                            type: "text",
                            readonly: _vm.produto.caixa_mista,
                            disabled: "",
                            placeholder: "Quantidade Caixa"
                          },
                          model: {
                            value: _vm.produto.qtd_caixa,
                            callback: function($$v) {
                              _vm.$set(_vm.produto, "qtd_caixa", $$v)
                            },
                            expression: "produto.qtd_caixa"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("label", [_vm._v("Preço")]),
                        _vm._v(" "),
                        _c("b-form-input", {
                          directives: [
                            {
                              name: "money",
                              rawName: "v-money",
                              value: _vm.money,
                              expression: "money"
                            }
                          ],
                          attrs: {
                            readonly: _vm.produto.caixa_mista,
                            disabled: ""
                          },
                          model: {
                            value: _vm.produto.preco_venda,
                            callback: function($$v) {
                              _vm.$set(_vm.produto, "preco_venda", $$v)
                            },
                            expression: "produto.preco_venda"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _vm.dataModal
                    ? _c(
                        "b-row",
                        { staticClass: "mt-3" },
                        [
                          _c("b-col", [
                            _c("b", [_vm._v(" Estoque:")]),
                            _vm._v(
                              " " +
                                _vm._s(_vm.dataModal.produto.estoque) +
                                "\n                    "
                            )
                          ]),
                          _vm._v(" "),
                          _c("b-col", [
                            _c("b", [_vm._v("Utilizado:")]),
                            _vm._v(
                              " " +
                                _vm._s(_vm.getUtilizado) +
                                "\n                    "
                            )
                          ]),
                          _vm._v(" "),
                          _c("b-col", [
                            _c("b", [_vm._v("Saldo:")]),
                            _vm._v(
                              " " +
                                _vm._s(_vm.getSaldo) +
                                "\n                    "
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.dataModal
                    ? _c(
                        "b-row",
                        { staticClass: "mt-3" },
                        [
                          _c("b-table", {
                            attrs: {
                              items: _vm.dataModal.data,
                              fields: _vm.fieldsPropostas,
                              striped: "",
                              small: "",
                              hover: "",
                              busy: _vm.loadingModal
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "table-busy",
                                  fn: function() {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-center text-primary my-2"
                                        },
                                        [
                                          _c("b-spinner", {
                                            staticClass: "align-middle"
                                          }),
                                          _vm._v(" "),
                                          _c("strong", [_vm._v("Buscando...")])
                                        ],
                                        1
                                      )
                                    ]
                                  },
                                  proxy: true
                                },
                                {
                                  key: "cell(proposta)",
                                  fn: function(row) {
                                    return [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href:
                                              "/venda-direta/proposta/" +
                                              row.item.id +
                                              "/edit",
                                            target: "_blank"
                                          }
                                        },
                                        [_vm._v(_vm._s(row.item.id))]
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "cell(pedido)",
                                  fn: function(row) {
                                    return [
                                      row.item.pedido
                                        ? _c(
                                            "a",
                                            {
                                              attrs: { href: "#" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.imprimirPedido(
                                                    row.item.pedido.id
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v(_vm._s(row.item.pedido.id))]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              728394835
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { size: "lg", title: "Importar Produtos" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function(ref) {
                var ok = ref.ok
                return [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        size: "sm",
                        variant: "primary",
                        disabled: _vm.loading
                      },
                      on: {
                        click: function($event) {
                          return _vm.importar()
                        }
                      }
                    },
                    [
                      _vm.loading
                        ? _c(
                            "span",
                            [
                              _c("b-spinner", {
                                attrs: { small: "", type: "grow" }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" Salvar\n            ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "danger" },
                      on: {
                        click: function($event) {
                          return ok()
                        }
                      }
                    },
                    [_vm._v("\n                Cancelar\n            ")]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.modalImportar,
            callback: function($$v) {
              _vm.modalImportar = $$v
            },
            expression: "modalImportar"
          }
        },
        [
          _c("div", { staticClass: "card p-3" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("b-form-file", {
                  attrs: {
                    state: Boolean(_vm.planilha),
                    placeholder: "Selecione uma planilha",
                    "drop-placeholder": "ou arraste até aqui"
                  },
                  on: { change: _vm.readFile },
                  model: {
                    value: _vm.planilha,
                    callback: function($$v) {
                      _vm.planilha = $$v
                    },
                    expression: "planilha"
                  }
                })
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("h1", { staticClass: "text-primary" }, [_vm._v("Produtos Varejo")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5cf760c2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cf760c2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/varejo/produtos/index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-5cf760c2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/varejo/produtos/index.vue
// module chunks = 2